// 🔗 SINGLE SOURCE OF TRUTH for every CTA on the site.
// All primary CTAs route directly to the qualifying quiz at /start.
// (The old /pages/quiz.html URL is kept as a redirect stub for legacy
// external/ad links — see public/pages/quiz.html.)
export const INTAKE_URL = "/start";
export const INTAKE_LIVE = true;

// Attribution params forwarded into the intake path (spec: utm_* + gclid only).
const ATTRIBUTION_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  "gclid",
];

// Matches the soft-capture form's mechanism: params are captured from the URL
// on page load into sessionStorage (vy_lead_param_* — see src/lib/leadCapture.js),
// so attribution survives SPA navigation. Live URL params take precedence.
// Empty/absent params are never appended.
function attributionQuery() {
  const out = new URLSearchParams();
  try {
    const live = new URLSearchParams(window.location.search);
    ATTRIBUTION_KEYS.forEach((k) => {
      const v = live.get(k) || sessionStorage.getItem("vy_lead_param_" + k);
      if (v) out.set(k, v);
    });
  } catch {
    /* non-fatal — navigate un-attributed */
  }
  return out.toString();
}

export const openIntake = () => {
  const qs = attributionQuery();
  window.location.href = qs ? `${INTAKE_URL}?${qs}` : INTAKE_URL;
};
